<template>
	<div class="login__div--page">
		<div class="lang-com">
			<el-dropdown @visible-change="change" @command="changeLang">
				<span class="account-el-dropdown-link">
					<img
						src="https://static-jp.theckb.com/static-asset/overseas/img/language_icon_black.png"
						alt=""
					/>
					<span>{{ isJA ? t("日文") : t("中文") }}</span>
					<img
						src="https://static-jp.theckb.com/static-asset/overseas/img/bell_black.png"
						alt=""
						:class="{ active: !visible }"
					/>
				</span>
				<el-dropdown-menu slot="dropdown" class="account-dropdown-menu">
					<el-dropdown-item
						style="width: 80px; text-align: center"
						:class="{ active: !isJA }"
						command="zh"
						>{{ t("中文") }}</el-dropdown-item
					>
					<el-dropdown-item
						style="width: 80px; text-align: center"
						:class="{ active: isJA }"
						command="ja"
						>{{ t("日文") }}</el-dropdown-item
					>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
		<div class="login__div--box">
			<img :src="logo" alt="logo" />
			<transition name="component-fade" mode="out-in">
				<component :is="comName" @change="changeCall"></component>
			</transition>
		</div>
	</div>
</template>

<script>
import { t } from "@/i18n/index";
import Login from "@/views/auth/components/Login";
import ChooseStorehouse from "@/views/auth/components/ChooseStorehouse";
import logo from "@/assets/logo.png";
import store from "@/store";
import { newImport } from "@/utils/common";
import { warehouses } from "@/mock/warehouses";
import menus from "@/mock/menus";
import { getMenu } from "@/apis/auth";

export default {
	name: "Auth",
	components: {
		Login,
		ChooseStorehouse,
	},
	data() {
		return {
			logo,
			// comName: 'ChooseStorehouse'
			comName: "Login",
			authInfo: null, // 登录返回的信息
			org: "",
			visible: false,
			t,
			isJA: false,
		};
	},
	mounted() {
		this.isJA = window.localStorage.getItem("lang") === "ja";
	},
	methods: {
		changeCall: function (payload) {
			const { comName, authInfo } = payload;
			this.comName = comName;
			if (authInfo) {
				this.authInfo = authInfo;
			}
			// console.log(this.authInfo)
		},
		createError() {
			console.error("error");
		},
		changeLang(lang) {
			console.log(lang);
			if ((this.isJA && lang === "ja") || (!this.isJA && lang === "zh")) return;
			// this.$i18n.locale = this.lang ? 'ja' : 'zh'
			window.localStorage.setItem("lang", lang === "zh" ? "zh" : "ja");
			setTimeout(() => {
				location.reload();
			});
		},

		change(e) {
			this.visible = e;
		},
	},
};
</script>
<style>
.account-dropdown-menu {
	padding: 6px 10px;
}
</style>
<style scoped lang="less">
.lang-com {
	position: fixed;
	top: 18px;
	right: 60px;
}
.account-el-dropdown-link {
	display: flex;
	align-items: center;
	color: #000;
	cursor: pointer;
	font-weight: 500;
	img {
		width: 16px;
		transform: rotate(180deg);
		&.active {
			transform: rotate(0);
		}
	}

	span {
		margin-left: 4px;
	}
}
.login__div--page {
	width: 100vw;
	height: 100vh;
	background: #fafafa;
	position: relative;
	top: 0;
	left: 0;
}

.login__div--box {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	margin: auto;
	width: 600px;
	height: 400px;
	background: white;
	padding: 24px;
	border-radius: 10px;
	box-sizing: border-box;
	box-shadow: 0 0 30px 10px rgba(0, 0, 0, 0.05);
	> img {
		width: 300px;
		margin-top: 30px;
		margin-bottom: 40px;
	}
	//动画
	.component-fade-enter-active,
	.component-fade-leave-active {
		transition: opacity 0.3s ease;
	}
	.component-fade-enter,
	.component-fade-leave-to {
		opacity: 0;
	}
}
</style>